import { formatRupeeLabel } from '../../../../../display-values/lumpsumPlanAmount'
import { LumpsumRecommendationActionType } from '../../../../api/common.types'
import type { LumpsumRebalanceUnderReviewRecommendation } from '../../../../api/rebalance.types'
import {
  PlanFundInsightVisual,
  PlansFundCard,
  type PlanFundCardInsight
} from '../../../lumpsum-ui-components/PlansFundCard'

type RebalanceUnderReviewFundCardProps = {
  recommendation: LumpsumRebalanceUnderReviewRecommendation
  showBottomDivider?: boolean
}

export function RebalanceUnderReviewFundCard({
  recommendation,
  showBottomDivider = true
}: RebalanceUnderReviewFundCardProps) {
  const isin = recommendation?.isin ?? ''
  const currentValue = recommendation?.currentValue ?? 0
  const insights = buildRebalanceUnderReviewInsights(recommendation)

  return (
    <PlansFundCard
      fund={{
        isin,
        logoUrl: recommendation?.mfLogoUrl ?? '',
        title: recommendation?.fundName ?? '',
        fundNature: recommendation?.fundNature ?? '',
        category: recommendation?.fundCategory ?? '',
        purchaseMode: recommendation?.purchaseMode ?? ''
      }}
      topRight={
        <div className="text-right shrink-0 -mt-[1px] text-[13px] font-[500] text-[#232323]">
          {formatRupeeLabel({ rawAmount: currentValue })}
        </div>
      }
      status={{
        rank: recommendation?.powerRank ?? 0,
        rating: recommendation?.powerRating ?? ''
      }}
      recommendationStatus={recommendation?.recommendationStatus}
      recommendationStatusDisplayText={recommendation?.recommendationStatusDisplayText}
      insights={insights}
      supportingText={recommendation?.underReviewReasonText ?? ''}
      showBottomDivider={showBottomDivider}
    />
  )
}

export function buildRebalanceUnderReviewInsights(
  recommendation: LumpsumRebalanceUnderReviewRecommendation
): PlanFundCardInsight[] {
  const isin = recommendation?.isin ?? ''
  const insights: PlanFundCardInsight[] = []
  const missedGains = recommendation?.missedGains ?? 0

  if (missedGains > 0) {
    insights.push({
      id: `${isin}-missed-gains`,
      text: `${formatRupeeLabel({ rawAmount: missedGains })} missed gains`,
      visual: PlanFundInsightVisual.WARNING
    })
  }

  if (recommendation?.highExposure) {
    const isBuy = recommendation?.actionType === LumpsumRecommendationActionType.BUY
    insights.push({
      id: `${isin}-rebalance-high-exposure`,
      text: isBuy ? 'Increase exposure' : 'High exposure (concentration risk)',
      visual: isBuy ? PlanFundInsightVisual.POSITIVE : PlanFundInsightVisual.ALLOCATION
    })
  }

  return insights
}
